export default __webpack_public_path__ + "static/media/oscer-tour-start-diagnosing.3818508e.svg";